export const Role = {
    Admin: 1,
    NMOAdmin: 2,
    HTCAdmin: 3
}